import { render, staticRenderFns } from "./TopicResearch.vue?vue&type=template&id=5ce7dc24&scoped=true&"
import script from "./TopicResearch.vue?vue&type=script&lang=js&"
export * from "./TopicResearch.vue?vue&type=script&lang=js&"
import style0 from "./TopicResearch.vue?vue&type=style&index=0&id=5ce7dc24&lang=sass&scoped=true&"
import style1 from "./TopicResearch.vue?vue&type=style&index=1&id=5ce7dc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7dc24",
  null
  
)

export default component.exports